"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const utils_1 = require("core/utils");
const React = __importStar(require("react"));
const useAmpli_1 = require("src/hooks/useAmpli");
const useNavigation_1 = require("src/hooks/useNavigation");
const layouts_1 = require("../shared/layouts");
const RoleSelect = () => {
    const [role, setRole] = React.useState(null);
    const coachSelected = role === 'coach';
    const teamMemberSelected = role === 'player';
    const { navigate, getState } = (0, useNavigation_1.useNavigation)();
    const isSignup = getState('isSignup');
    const { screenViewed, onboardingButtonClicked } = (0, useAmpli_1.useAmpli)();
    const onNext = () => {
        onboardingButtonClicked('Next', 'Onboarding: Role Selection');
        role === 'coach' ? navigate.v1CreateTeam({ isSignup }) : navigate.goToClassicFindTeam();
    };
    React.useEffect(() => {
        screenViewed(useAmpli_1.AmplitudeScreenNames.ROLE_SELECT);
    }, []);
    return (React.createElement(layouts_1.SplitWrapper, null,
        React.createElement(layouts_1.FormWrapper, null,
            React.createElement("div", { className: "sui-heading-md sui-mb-2" }, "Create or join a team"),
            React.createElement("div", null,
                React.createElement(snap_ui_1.BorderedRadio, { className: "sui-mb-1 sui-p-2", label: "Create a new team", caption: "Start a team and invite others to join.", selected: coachSelected, value: "coach", onSelect: () => {
                        setRole('coach');
                    } }),
                React.createElement(snap_ui_1.BorderedRadio, { className: "sui-p-2", label: "Join an existing team", caption: "Accept an invite or find your team.", selected: teamMemberSelected, "data-testid": "player-radio", value: "player", onSelect: () => {
                        setRole('player');
                    } }),
                React.createElement(snap_ui_1.LabelButton, { "data-testid": "next-button", className: "sui-mt-2 sui-min-w-full", labelText: "Next", sentiment: "default", onClick: onNext, size: "default", variantType: "primary", disabled: !role })),
            React.createElement("p", { className: "sui-body-dense sui-text-center sui-mt-3 sui-mb-0" }, "Club, league, or tournament administrator?"),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "request-tsb-demo", className: "sui-mb-3 sui-w-full", style: { height: '2rem' }, labelText: "Request a TeamSnap for Business demo", onClick: utils_1.redirectToTSBDemoForm, size: "default", variantType: "tertiary" }))));
};
exports.default = RoleSelect;
